## Bearer token

Envíe siempre la credencial en el header `Authorization`.

Formato esperado:

`Authorization: Bearer ctt_live_<key_id>.<secret>`

## Cómo funciona la autenticación

- Cada credencial siempre está vinculada a una organización.
- La organización autenticada nace de la propia credencial, no de un header extra de contexto.
- El secreto bruto se muestra solo en la creación y en la rotación.

## Cómo obtener una clave

Abra [Mi cuenta > API pública](/account?tab=settings&settings_tab=public_api) y cree una credencial para la integración.

La creación y la rotación muestran el bearer token completo una sola vez. Guarde el valor completo en un gestor de secretos. Después de eso, el producto solo muestra el `key_id` y los últimos 4 caracteres del secreto.

El área de API pública solo aparece para organizaciones con una suscripción activa en un plan que habilita la API pública.

## Alcances

- Cada credencial lleva únicamente los alcances asignados explícitamente a ella.
- Los alcances efectivos pueden consultarse en el endpoint de catálogo de scopes.
- Si falta un alcance requerido, la API debe responder con error de autorización.
- Alcances implementados: `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read` y `transfer_groups.read`.

## Allowlist, expiración y throttling

- Cuando exista `allowed_ips`, la llamada solo se acepta si el IP del cliente está en la allowlist.
- Si la credencial está expirada o revocada, la autenticación debe fallar.
- El throttling se aplica por credencial, respetando el límite configurado para esa clave.

## Errores más comunes

- `401 Unauthorized`: token ausente, inválido, expirado, revocado o IP no permitido.
- `403 Forbidden`: la credencial autenticó, pero no tiene el alcance necesario para la operación.
- `429 Too Many Requests`: la credencial excedió el límite permitido en la ventana actual.
